export const PASSWORD_MIN_LENGTH = 12;

const PASSWORD_CLASSES = [
  { matcher: /[a-z]/, issue: 'Add a lowercase letter.' },
  { matcher: /[A-Z]/, issue: 'Add an uppercase letter.' },
  { matcher: /\d/, issue: 'Add a number.' },
  { matcher: /[^A-Za-z0-9]/, issue: 'Add a symbol.' },
];

export function passwordStrengthOk(password: string): boolean {
  if (!password || password.length < PASSWORD_MIN_LENGTH) {
    return false;
  }
  let matches = 0;
  for (const { matcher } of PASSWORD_CLASSES) {
    if (matcher.test(password)) {
      matches += 1;
    }
  }
  return matches >= 3;
}

export function getPasswordPolicyIssues(password: string): string[] {
  const issues: string[] = [];
  if (!password || password.length < PASSWORD_MIN_LENGTH) {
    issues.push(`Must be at least ${PASSWORD_MIN_LENGTH} characters.`);
  }
  for (const { matcher, issue } of PASSWORD_CLASSES) {
    if (!matcher.test(password)) {
      issues.push(issue);
    }
  }
  return issues;
}
